/**
 * Confirm.
 * @param {object} button
 */
window.confirm = function(button) {
    bootbox.confirm({
        title: button.attr("data-title"),
        message: button.attr("data-message"),
        buttons: {
            cancel: {
                label: 'No',
                className: 'btn-outline-primary'
            },
            confirm: {
                label: 'Yes',
                className: 'btn-success'
            }
        },
        callback: function (result) {
            if (result === false) {
                return;
            }
            window.location.href = button.attr("data-url");
        }
    });
};
